import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import TasksList from './components/TasksList'
import useToken from 'token/shared/hooks/useToken'
import useGateway from 'shared/hooks/useGateway'

const Container = () => {
  const { workflowUuid } = useParams()

  const { token, metadata, isFetching } = useToken({ tokenUuid: workflowUuid })

  const { navigateToTaskScreen } = useGateway()

  useEffect(() => {
    if (isFetching) return
    if (!token) {
      navigateToTaskScreen()
    }
  }, [isFetching, token, navigateToTaskScreen])

  if (isFetching) {
    return null
  }

  return (
    <div>
      {token?.uuid}
      <br />
      <br />
      {token && <TasksList token={token} metadata={metadata} />}
    </div>
  )
}

export default Container
